import { styled } from '@linaria/react';

export const Logo = styled.svg`
  display: block;
  height: 24px;
`;
